module.exports = __webpack_public_path__ + "img/image(3)-1.98faab1c.png";